import axios from "axios";
import { chunk } from "lodash";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { Security } from "./Types";
const Response = Security.array();
export const url = (securityIds) => {
    const pageSize = securityIds.length ?? 20; // 20 is a good default page size
    const queryString = securityIds.join("&id=");
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/secmaster/v1/security?id=${queryString}&pageSize=${pageSize}&followerRead=true`
        : `https://middleware.uat.farther.com/secmaster/v1/security?id=${queryString}&pageSize=${pageSize}&followerRead=true`;
};
export default async function getSecuritiesBySecurityIds(securityIds, config) {
    // We may get very large number of security ids and thus get a 414 from the
    // security master API. By chunking into smaller arrays we can avoid the 414.
    const secIdChunks = chunk(securityIds, 20);
    const allChunks = await Promise.all(secIdChunks.map(async (subArrayOfSecurityIds) => {
        const { data } = await axios.get(url(subArrayOfSecurityIds), {
            headers: {
                Authorization: `Bearer ${config.jwt}`,
                ...("advisorId" in config && { Advisor: config.advisorId }),
                ...("clientId" in config && { Client: config.clientId }),
            },
        });
        const decoded = Response.safeParse(data);
        if (decoded.success) {
            return decoded.data;
        }
        else {
            const errorMessage = "[getSecuritiesBySecurityIds] Could not parse";
            errorLog(errorMessage, decoded.error.message);
            throw new ValidationError(errorMessage, decoded.error.issues);
        }
    }));
    return allChunks.flat(1);
}
//# sourceMappingURL=getSecuritiesBySecurityIds.js.map